import { Link as GatsbyLink } from "gatsby";
import styled from "@emotion/styled";

const Link = styled(GatsbyLink)({}, ({ disabled }) => {
  return {
    pointerEvents: disabled ? "none" : "auto",
  };
});

export default Link;
